<template>
  <div class="flex justify-between items-center">
    <div class="row items-center q-pa-md">
      <q-img :src="productImage" style="width:100px; height:100px" class="rounded-borders q-mr-md q-mb-md" />
      <div class="dass-info-product">
        <span class="text-subtitle1 text-weight-bold">{{ productTitle }}</span>
        <span class="text-caption">{{ orderDate }}</span>
        <span class="text-caption">{{$t('dass.nOrder') }}:<b class="q-ml-sm">{{ orderNumber }}</b></span>
      </div>
    </div>
    <div class="flex items-center q-gutter-sm" style="margin-left: auto;">
      <span>{{ $t('protocolo.status') }}:</span>
      <CardStatusOrder :statusPed="statusPed" />
    </div>
  </div>
</template>
<script>
import CardStatusOrder from '../home/CardStatusOrder.vue';
export default {
  name: 'OrderTrackingHeader',
  props: {
    productImage: String,
    productTitle: String,
    orderDate: String,
    orderNumber: String,
    statusPed: String
  },
  components: {
    CardStatusOrder
  }  
};
</script>
<style scoped>
.dass-info-product {
  display: flex;
  flex-direction: column; 
  span:nth-child(2) {
    color: var(--theme-gray)
  }
}
</style>